<template>
  <el-card class="sky-hc-img-card" @click.native="handleReportArticle">
    <div class="sky-hc-img-card__img-box">
      <img
        :src="data.coverUrl ? data.coverUrl : defaultImg"
        @error="data.coverUrl = defaultImg"
        class="sky-hc-img-card__img"
      />
      <!-- <img
        v-if="data.hot"
        class="sky-hc-img-card__icon-hot"
        src="@/assets/images/help/icon_top_hot.png"
        srcset="@/assets/images/help/icon_top_hot@2x.png"
        data-type="jpeg"
        data-w="1280"
      /> -->
    </div>
    <div class="sky-hc-img-card__con" :class="showCategory ? '' : 'sky-hc-img-card__con--no-category'">
      <div class="sky-hc-img-card__tit" :class="{'sky-hc-img-card__tit--hot': data.hot}">{{ data.title }}</div>
      <div class="sky-hc-img-card__txt" v-if="showCategory">{{ data.category.name }}</div>

      <div class="sky-hc-img-card__con--hot" v-if="data.hot">{{$t('help.hot')}}</div>
    </div>
  </el-card>
</template>
<script>
import { Card } from 'element-ui'

import { reportClick } from '@/api/help'
import { CATEGORY_TYPE } from '@/utils/enum'
export default {
  name: 'HelpImgCard',
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    showCategory: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      defaultImg: require('@/assets/images/help/default.png')
    }
  },
  components: {
    [Card.name]: Card
  },
  methods: {
    handleReportArticle() {
      reportClick({
        resourceId: this.data.id,
        type: CATEGORY_TYPE.ARTICLE
      })
      window.open(this.data.url, 'help')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-img-card) {
  box-shadow: none;
  width: calc((100% - 42px) / 3);
  margin-right: 21px;

  margin-bottom: 21px;
  cursor: pointer;

  &:nth-child(3n) {
    margin-right: 0px;
  }
  @include e(img-box) {
    width: 100%;
    height: 148px;
    position: relative;
  }
  @include e(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @include e(con) {
    width: 100%;
    display: block;
    padding: 0px 19px;
    border: 1px solid #979797;
    border-top: 0px;
    height: 103px;
    box-sizing: border-box;
    border-bottom: 1px solid #979797;
    padding-bottom: 20px;
    position: relative;
    overflow: hidden;
    @include m(no-category) {
      height: fit-content;
    }
    @include m(hot){

      position: absolute;
      width: 120px;
      line-height: 24px;
      background:#D0021B ;
      transform: rotate(45deg);
      text-align: center;
      color:#ffffff;
      right: -38px;
      top: 10px;
      font-size: $--font-size-middle;
    }
  }
  @include e(tit) {
    font-size: 20px;
    color: $--color-grey-8;
    font-weight: bold;
    line-height: 26px;
    padding-top: 13px;
    height: 61px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    @include m(hot){
      padding-right: 30px;
    }
  }
  @include e(txt) {
    font-size: $--size-base;
    margin-top: 3px;
    color: $--color-grey-8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
  }
  @include e(icon-hot) {
    display: block;
    width: 52px;
    height: 44px;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 2;
  }
}
</style>
<style lang="scss">
.sky-hc-img-card {
  .el-card__body {
    padding: 0px;
  }
}
</style>
